import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { MainAppState } from "../appState/models";
import { MdmActivity } from "./models";

export const mdmActivitySelector = createDraftSafeSelector(
  (state: MainAppState) => state,
  (state: MainAppState) => state.mdmActivity.mdmActivity,
);

// Selector for selectedUnit
export const selectedUnitSelector = createDraftSafeSelector(
  mdmActivitySelector,
  (state: MdmActivity) => state.selectedUnit,
);

// Selector for topicList
export const topicListSelector = createDraftSafeSelector(
  mdmActivitySelector,
  (state: MdmActivity) => state.topicList,
);

// Selector for activityFramework
export const activityFrameworkSelector = createDraftSafeSelector(
  mdmActivitySelector,
  (state: MdmActivity) => state.activityFramework,
);
